import { NavMenu } from '@/modules/core/components/molecules/NavMenu';
import MainFooter from '@/modules/core/components/molecules/MainFooter';


const SubPage = () => {
  return (
    <>
      <NavMenu />

      <MainFooter />
    </>
  );
};

export default SubPage;
